"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_MEDIA_LINK_SECONDS = exports.manualOrderStatus = exports.MANUAL_ORDER_AUDIO_TYPES = exports.MANUAL_ORDER_IMAGE_TYPES = exports.MANUAL_ORDER_LIMITS = void 0;
const order_1 = require("./order");
/**
 * What one order taken in the app may hold. The API refuses more; the capture screen keeps to
 * it (photos compressed on the phone to a 1600 px long edge, a voice note of at most 2 minutes).
 */
exports.MANUAL_ORDER_LIMITS = {
    maxImages: 5,
    maxImageBytes: 2 * 1024 * 1024,
    maxAudio: 1,
    maxAudioBytes: 10 * 1024 * 1024,
    maxAudioSeconds: 120,
    maxTextLength: 2000,
    maxNoteLength: 500,
};
/** Photo types the API takes, by what the file actually is (not what it claims). */
exports.MANUAL_ORDER_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
/** Voice notes: webm/opus (Android Chrome), ogg/opus, mp4/m4a (iOS Safari). */
exports.MANUAL_ORDER_AUDIO_TYPES = ['audio/webm', 'audio/ogg', 'audio/mp4'];
const manualOrderStatus = (state) => {
    switch (state) {
        case order_1.OrderState.RECEIVED:
            return 'submitted';
        case order_1.OrderState.PARSING:
        case order_1.OrderState.MATCHED:
            return 'processing';
        case order_1.OrderState.APPROVED:
        case order_1.OrderState.POSTING:
            return 'approved';
        case order_1.OrderState.POSTED:
            return 'posted';
        case order_1.OrderState.CANCELLED:
            return 'rejected';
        // READY, NEEDS_INFO, FAILED: with staff, one way or another.
        default:
            return 'needs_review';
    }
};
exports.manualOrderStatus = manualOrderStatus;
/** How long a media link of an order taken in the app works. */
exports.ORDER_MEDIA_LINK_SECONDS = 600;
//# sourceMappingURL=intake.js.map